import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { SwiperType } from "@components-shared/mobile/swiper/SwiperType";
import { SwiperWrapper } from "@components-shared/mobile/swiper/SwiperWrapper";
import { EventContext } from "@gp/components";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { THEME_SETTINGS } from "@theme-settings";
import { observer } from "mobx-react";

import { BettingTypeHeaderBettingGroupsButton } from "./BettingTypeHeaderBettingGroupsButton";

type BettingTypeHeaderBettingGroupsButtonInfo = {
	abrv: string;
	name: string;
};

export const GroupedBettingTypesHeader = observer(
	function GroupedBettingTypesHeader() {
		const { t } = useTranslation();

		const event = useContext(EventContext);
		const store = useOfferContext<OfferStore.EventViewStore>();
		const bettingGroups: BettingTypeHeaderBettingGroupsButtonInfo[] =
			(function () {
				const favoritesBetting =
					store.favoritesBettingTypeGroups?.[event.id];

				const isFavoritesEmpty =
					favoritesBetting &&
					// @ts-expect-error
					(event.favoritesBettingTypesIds?.length ?? 0) === 0;

				const isBetBuilderAvailable =
					event.betBuilder && store.betBuilderBettingType.length > 0;

				const bettingGroups: BettingTypeHeaderBettingGroupsButtonInfo[] =
					[];

				bettingGroups.push({
					abrv: "all",
					name: t("BETTING_GROUPS.ALL"),
				});

				if (WEBPACK_IS_BET_BUILDER_ENABLED && isBetBuilderAvailable) {
					bettingGroups.push({
						abrv: "bet-builder",
						name: "Bet Builder",
					});
				}

				if (
					THEME_SETTINGS.features.isFavoritesEnabled &&
					!isFavoritesEmpty
				) {
					bettingGroups.push({
						abrv: "favorites",
						name: t("LIVE.SIDEMENU.FAVORITES"),
					});
				}

				store.bettingTypeGroups.forEach((btg) =>
					bettingGroups.push(btg)
				);

				return bettingGroups;
			})();

		return (
			<>
				<div className="event__tabs event__tabs--groups">
					<div className="tabs tabs--boxed tabs--scroll--full scrollbar--custom">
						<SwiperWrapper
							type={SwiperType.SHOW_FIRST}
							customSpacing={8}
						>
							{bettingGroups.map((btg, index) => (
								<SwiperWrapper.SliderItem
									key={btg.abrv}
									isActive={
										store.displayBettingGroup === btg.abrv
									}
									tabIndex={index}
								>
									<BettingTypeHeaderBettingGroupsButton
										bettingTypeGroup={btg}
										tabIndex={index}
									/>
								</SwiperWrapper.SliderItem>
							))}
						</SwiperWrapper>
					</div>
				</div>
			</>
		);
	}
);
